import { useStytchB2BClient } from '@stytch/react/b2b';
import type { StytchB2BUIClient } from '@stytch/vanilla-js/b2b';
import type { StytchB2BHeadlessClient } from '@stytch/vanilla-js/dist/b2b/index.headless';
import { useCallback } from 'react';

export async function getToken(client: StytchB2BUIClient | StytchB2BHeadlessClient) {
    const tokens = client.session.getTokens();

    if (!tokens) {
        const refresh = await client.session.authenticate();
        return refresh.session_jwt;
    }

    return tokens.session_jwt;
}

export default function useGetToken() {
    const stytch = useStytchB2BClient();

    return useCallback(async () => {
        return await getToken(stytch);
    }, [stytch])
}